export default __webpack_public_path__ + "static/dan-about-bio-fe8ea135ee88a354c7923c3d3e27bd46.jpg";